import * as types from './types';

const dutyPlannerDataReceived = (startTime, endTime, groupId, readOnly) => ({
  type: types.DUTY_PLANNER_DATA_RECEIVED,
  payload: {
    startTime,
    endTime,
    groupId,
    readOnly
  }
});

export { dutyPlannerDataReceived };
